module.exports = __webpack_public_path__ + "static/img/box@3x.f44541d.png";